import React, { useState, useEffect } from 'react';
import { useLang } from '../LangContext';
import { WalletButton, WalletModal } from './Web3Modal';

export default function Navbar() {
  const { t, lang, toggleLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [showWallet, setShowWallet] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { key: 'features',   label: t.nav.features,   href: '#fitur' },
    { key: 'platforms',  label: t.nav.platforms,  href: '#platform' },
    { key: 'howItWorks', label: t.nav.howItWorks, href: '#panduan' },
    { key: 'web3',       label: 'Web3 Pro',       href: '#web3' },
    { key: 'faq',        label: t.nav.faq,        href: '#faq' },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 2rem', height: '60px',
        background: scrolled ? 'rgba(10,10,10,0.88)' : 'transparent',
        backdropFilter: scrolled ? 'blur(14px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : 'none',
        transition: 'background 0.3s, border-bottom 0.3s',
      }}>
        <div style={{
          fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '20px',
          color: 'var(--text)', letterSpacing: '-0.02em', cursor: 'pointer',
        }}>
          Grab<span style={{ color: 'var(--brand)' }}>Watch</span><span style={{ color: 'var(--brand)' }}>.</span>
        </div>

        <ul style={{ display: 'flex', alignItems: 'center', gap: '1.75rem', listStyle: 'none' }}>
          {navLinks.map(({ key, label, href }) => (
            <li key={key}>
              <a href={href} style={{
                color: key === 'web3'
                  ? (hovered === key ? '#A855F7' : 'rgba(168,85,247,0.7)')
                  : (hovered === key ? 'var(--text)' : 'var(--text2)'),
                textDecoration: 'none', fontSize: '14px', transition: 'color 0.15s',
                fontWeight: key === 'web3' ? 500 : 400,
              }}
                onMouseEnter={() => setHovered(key)}
                onMouseLeave={() => setHovered(null)}
              >{label}</a>
            </li>
          ))}
        </ul>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Wallet button */}
          <WalletButton onClick={() => setShowWallet(true)} />

          {/* Language Toggle */}
          <button onClick={toggleLang} style={{
            display: 'flex', alignItems: 'center', gap: '5px',
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px', padding: '6px 10px',
            color: 'var(--text2)', fontSize: '12px', fontWeight: 600,
            fontFamily: 'var(--font-body)', cursor: 'pointer', transition: 'all 0.15s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'var(--text)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.color = 'var(--text2)'; }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
            </svg>
            {lang.toUpperCase()}
          </button>

          <button style={{
            display: 'none',
            background: 'var(--brand)', color: 'white', border: 'none',
            borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: 500,
            fontFamily: 'var(--font-body)', cursor: 'pointer', transition: 'background 0.15s, transform 0.1s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'var(--brand-dark)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'var(--brand)'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            {t.nav.tryPro}
          </button>
        </div>
      </nav>

      {showWallet && <WalletModal onClose={() => setShowWallet(false)} />}
    </>
  );
}
